import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { savePendingSharedRoute } from "../utils/portalAluno/sharedContentLink";

const LoginRedirect = () => {
  const { pathname, search } = useLocation();

  React.useEffect(() => {
    savePendingSharedRoute(pathname, search);
  }, [pathname, search]);

  return <Navigate replace to="/auth" />;
};

export default LoginRedirect;
